import { QRCodeSVG } from "qrcode.react";
import { useState } from "react";
import { buildAffiliatePartnerUrl } from "../../../helpers/general";

export default function PartnerQrTab({ user }: { user: User }) {
  const [copied, setCopied] = useState(false);
  const slug = (user as any).partnerPlaceSlug as string | undefined;
  const url = buildAffiliatePartnerUrl(slug);

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const download = () => {
    const svg = document.querySelector("#partner-qr");
    if (!svg) return;
    const blob = new Blob([new XMLSerializer().serializeToString(svg)], {
      type: "image/svg+xml;charset=utf-8",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `venez-${slug ?? "partenaire"}.svg`;
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <div
      className="bg-white rounded-4 shadow-sm overflow-hidden mt-3 mx-auto"
      style={{ maxWidth: 480 }}
    >
      <div className="bg-gradient-primary text-white px-4 py-3">
        <p className="text-xs text-uppercase mb-1">
          Expérience recommandée par
        </p>
        <h5 className="fw-bold mb-0">{user.fullName}</h5>
      </div>
      <div className="p-4 text-center">
        <h6 className="fw-bold">Découvrez venez.ma</h6>
        <p className="text-sm text-secondary">
          Scannez pour découvrir et réserver sur venez.ma
        </p>
        {slug ? (
          <>
            <div className="d-inline-block border rounded-4 p-3 shadow-sm">
              <QRCodeSVG id="partner-qr" value={url} size={220} level="H" />
            </div>
            <div className="mt-3">
              <button
                type="button"
                className="btn btn-danger text-white rounded-pill px-4"
                onClick={download}
              >
                Télécharger le QR
              </button>
            </div>
            <div className="bg-light rounded-3 p-3 mt-4 text-start">
              <p className="text-xs fw-bold text-uppercase text-secondary mb-1">
                Lien partenaire
              </p>
              <p className="text-sm text-break mb-2">{url}</p>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm w-100"
                onClick={copy}
              >
                {copied ? "Lien copié" : "Copier le lien"}
              </button>
            </div>
          </>
        ) : (
          <p className="text-danger text-sm">
            Ce partenaire n’a pas encore de code partenaire (partnerPlaceSlug).
          </p>
        )}
      </div>
    </div>
  );
}
